module.exports = __webpack_public_path__ + "static/media/s18.ffb1e552.png";